import { render, staticRenderFns } from "./productAiTable.vue?vue&type=template&id=ac70b216&"
import script from "./productAiTable.vue?vue&type=script&lang=js&"
export * from "./productAiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports